import { MenuItem } from '@mui/material';

import { TextField } from 'components/TextField';
import SearchInput from 'src/components/SearchInput';
import { TableFilterRow } from 'src/components/TableList';

import {
  SubscribedListingFilterProps,
  UnsubscribedListingFilterProps
} from './types';

export const SubscribedListingFilter = ({
  onPageChange,
  params
}: SubscribedListingFilterProps): JSX.Element => {
  const handleSearch = (value: string) => {
    onPageChange({ search: value || undefined, offset: undefined });
  };

  return (
    <TableFilterRow>
      <SearchInput
        onSearch={handleSearch} // todo: pass search query param as value
        placeholder={'Search for employee names or emails'}
        value={(params.search as string) || ''}
      />
    </TableFilterRow>
  );
};

export const UnsubscribedListingFilter = ({
  onPageChange,
  params,
  departments
}: UnsubscribedListingFilterProps): JSX.Element => {
  const handleSearch = (value: string) => {
    onPageChange({ search: value || undefined, offset: undefined });
  };

  return (
    <TableFilterRow>
      <SearchInput
        onSearch={handleSearch}
        placeholder={'Search for employee names or emails'}
        value={(params.search as string) || ''}
        sx={{
          width: '100%'
        }}
      />
      <TextField
        select
        id="department"
        name="departments"
        label="Department"
        value={params.departments ?? ''}
        onChange={(e) => onPageChange({ [e.target.name]: e.target.value })}
      >
        {departments.map((dept) => (
          <MenuItem key={dept.id} value={dept.id}>
            {dept.name}
          </MenuItem>
        ))}
      </TextField>
    </TableFilterRow>
  );
};
